var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{class:[
    'sw-Image',
    { 'sw-Image-placeholder': _vm.showPlaceholder },
    { 'sw-Image-stateLoader': _vm.showLoader },
    { 'ui-image-lazyLoad': _vm.isLazy }],attrs:{"alt":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }